// extracted by mini-css-extract-plugin
export var tosLink = "_bk-0";